module.exports = __webpack_public_path__ + "static/media/grey-t-shirt.bd90c44c.jpg";